import apiHandler from "../core/apiHandler";

const paymentMethodApi = apiHandler('payment-methods');
export default paymentMethodApi;